import { Injectable } from '@angular/core'
import { MatStepper } from '@angular/material/stepper'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbEventTicketPurchaseStepperViewController {
  selectedStepSubject$ = new BehaviorSubject<number>(0)
  selectedStep$ = this.selectedStepSubject$.asObservable()
  private _matStepper!: MatStepper

  set matStepper(matStepper: MatStepper) {
    this._matStepper = matStepper
  }

  get matStepper(): MatStepper {
    return this._matStepper
  }

  progressStepper(): void {
    this.matStepper.next()
  }
}
